"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Label_1 = __importDefault(require("../Label"));
var Typography_1 = __importDefault(require("../Typography"));
var styles_1 = require("./styles");
var Radio = function (_a) {
    var _b, _c;
    var label = _a.label, required = _a.required, value = _a.value, onChange = _a.onChange, options = _a.options, _d = _a.flexDirection, flexDirection = _d === void 0 ? 'column' : _d;
    var handleChange = function (_a) {
        var target = _a.target;
        onChange(target.value);
    };
    return ((0, jsx_runtime_1.jsxs)(styles_1.Container, { children: [label && ((0, jsx_runtime_1.jsx)(Label_1.default, __assign({ required: required, htmlFor: "".concat(((_b = options[0]) === null || _b === void 0 ? void 0 : _b.testId) || 'radio', "-radiogroup") }, { children: label }))), (0, jsx_runtime_1.jsx)(styles_1.Options, __assign({ style: { flexDirection: flexDirection }, role: "radiogroup", "aria-label": label || '', id: "".concat(((_c = options[0]) === null || _c === void 0 ? void 0 : _c.testId) || 'radio', "-radiogroup") }, { children: options.map(function (option) { return ((0, jsx_runtime_1.jsxs)(styles_1.RadioLabel, { children: [(0, jsx_runtime_1.jsx)("input", { type: "radio", value: option.value, checked: value === option.value, onChange: handleChange, "data-testid": "".concat(option.testId, "-radio"), "aria-label": option.label, "aria-checked": value === option.value, "aria-required": required }), (0, jsx_runtime_1.jsx)(Typography_1.default.Body, __assign({ as: "span" }, { children: option.label }))] }, option.value)); }) }))] }));
};
exports.default = Radio;
